import React from 'react';
import { Loader } from '../../../web-runtime/loader';
export var getLoadingComponent = function getLoadingComponent(loadingComponent) {
  if (loadingComponent) {
    return typeof loadingComponent === 'function' ? loadingComponent() : loadingComponent;
  }
  return /*#__PURE__*/React.createElement(Loader, null);
};